<template>
  <div class="relative">
    <tooltip ref="tooltip" @hide="$emit('hide')" @show="$emit('show')">
      <template #trigger="{ show, hide }">
        <div class="relative">
          <input
            class="search-input w-full"
            :class="{ 'is-empty': !value[0], 'cursor-not-allowed': disabled }"
            placeholder="Dates (optional)"
            readonly
            :disabled="disabled"
            :value="dateDisplay"
            @focus="show"
            @keydown.tab="hide"
            tabindex="2001"
          />

          <svg
            width="20"
            height="20"
            class="search-icon text-black-light-5"
            fill="currentColor"
          >
            <use xlink:href="/img/sprite.svg#ic_calendar"></use>
          </svg>
        </div>
      </template>

      <template #default="{ hide }">
        <div
          class="drop-panel"
          :class="{
            'month-picker': searchType === 'liveaboard',
            'range-picker': searchType === 'resort' || searchType === 'yacht',
            'single-picker': searchType === 'ecoventure',
          }"
        >
          <date-picker
            v-if="searchType === 'ecoventure'"
            :value="value[0]"
            @input="handleEmitSingleDatePicker"
            @close="hide"
          />
          <month-picker
            v-else-if="searchType === 'liveaboard'"
            :dates="value"
            @input="handleMonthSelected"
            @close="hide"
          />
          <date-range-picker
            v-else
            :value="value"
            @input="$emit('input', $event)"
            @close="hide"
          />
        </div>
      </template>
    </tooltip>
  </div>
</template>

<script>
import Tooltip from "../../core/Tooltip";
import DatePicker from "../../core/DatePicker";
import DateRangePicker from "../../core/DateRangePicker/customized";
import MonthPicker from "../../core/MonthPicker";
import { getBookingDateDisplay } from "../../../helpers";

export default {
  components: {
    Tooltip,
    DatePicker,
    DateRangePicker,
    MonthPicker,
  },
  props: ["value", "searchType", "disabled"],
  computed: {
    dateDisplay() {
      const from = this.value[0];
      const to = this.value[1];

      if (this.searchType === "liveaboard") {
        if (from) {
          return from.format("MMM YYYY");
        }

        return "Month (optional)";
      }

      const selected = getBookingDateDisplay(from, to);

      if (selected.length === 0) {
        if (this.searchType === "liveaboard") {
          return "Month (optional)";
        }

        return "Dates (optional)";
      }

      return selected.join(" — ");
    },
  },
  methods: {
    handleMonthSelected(value) {
      this.$emit("input", value);
      this.$refs.tooltip.hide();
    },
    handleEmitSingleDatePicker(from) {
      this.$emit("input", [from, null]);
      this.$refs.tooltip.hide();
    },
  },
};
</script>

<style scoped>
.search-input {
  border: none;
  padding-right: 0;
}

.drop-panel {
  transform: translateX(-50%);
  left: 50%;
  padding: 1rem;
  z-index: 10;
}

.drop-panel.range-picker {
  width: 750px;
}

.drop-panel.single-picker {
  width: 375px;
}

.drop-panel.month-picker {
  width: 350px;
}

.is-empty {
  color: var(--black-light-3);
}
</style>
